export const cx = (...args: string[]): string =>
  args.filter((item) => item && item !== '' && item !== 'undefined').join(' ');
